import React from 'react';
import Head from '../components/Head';
import { Box } from '../components/SimpleUI';
import { useCountry } from '../contexts/CountryContext';
import NewHome from '../components/Home/NewHome/NewHome';

const Home = () => {
  const { countryPrefix } = useCountry();
  const isArg = countryPrefix === '/ar';
  const pageTitle = 'Descubre nuestros proyectos de inversión en real estate';
  const pageDescription =
    '¿Querés invertir en Real Estate? Encontrá una amplia variedad de proyectos inmobiliarios en Simplestate. Contamos con inversiones a medida para vos. Ingresá ahora.';

  return (
    <Head title={pageTitle} description={pageDescription}>
      <Box tag="section" position="relative">
        <NewHome />
      </Box>
    </Head>
  );
};

export default Home;
